import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 16px 80px 0;
    width: 328px;
    max-width: 100%;
    max-height: 567px;

    @media screen and (max-width: ${theme.breakpoints.md}) {
      margin: 16px 30px 0;
    }

    @media screen and (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
      margin: 16px 0 0;
    }

    > main {
      display: flex;
      flex-direction: column;
      align-items: center;

      > span {
        &:first-of-type {
          margin-bottom: 33px;
        }
      }

      > div {
        &:first-of-type {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 16px;

          > div {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            > div {
              display: flex;
              align-items: center;
              gap: 4px;
            }
          }
        }

        &:last-of-type {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 16px;

          > div {
            max-height: 400px;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 4px;
            overflow: visible;

            &::-webkit-scrollbar,
            &::-webkit-scrollbar-thumb {
              width: 26px;
              border-radius: 13px;
              background-clip: padding-box;
              border: 10px solid transparent;
            }

            &::-webkit-scrollbar-thumb {
              box-shadow: inset 0 0 0 10px;
            }
          }
        }
      }
    }
  `}
`;

export const Separator = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin: 16px 0;
    display: flex;
    align-items: center;
    text-align: center;

    &:before,
    &:after {
      content: '';
      flex: 1;
      border-bottom: 1px solid ${theme.colors.grey7};
    }

    &:before {
      margin-right: 4px;
    }

    &:after {
      margin-left: 4px;
    }
  `}
`;
